import { IApplicationState } from '../../types/redux';

export const selectEmptyListingSuggestions = (state: IApplicationState) => state.emptyListingSuggestions;
